import { render, staticRenderFns } from "./cishanMedicine.vue?vue&type=template&id=5e9bc968&scoped=true"
import script from "./cishanMedicine.vue?vue&type=script&lang=js"
export * from "./cishanMedicine.vue?vue&type=script&lang=js"
import style0 from "./cishanMedicine.vue?vue&type=style&index=0&id=5e9bc968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9bc968",
  null
  
)

export default component.exports